import axios from 'axios'
import GlobalFun from '@/global/global-function'
// 公共变量
import GlobalVariable from '@/global/global-variable'
import store from '@/store/index'
import {Notification, MessageBox, Message} from 'element-ui'
import Cookies from 'js-cookie'
import JSZip from "jszip";
import FileSaver from "file-saver";

/**
 * 使用拦截器
 */
axios.interceptors.request.use(
    (config) => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        // 身份证 读卡器 放过
        if (config.url.indexOf(GlobalVariable.BASE_PATH_IDCARD) == 0) return config;
        config.headers.token = store.state.token
        config.headers.lang = store.state.lang
        config.headers.loginDevice = store.state.loginDevice
        config.headers.apiKey = store.state.apiKey == '' ? '1' : store.state.apiKey
        // config.headers.appId = store.state.appId
        return config;
    },
    error => {
        // 对请求错误做些什么
        console.log('error');
        return Promise.error(error);
    }
)

/**
 * 响应拦截器
 */
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            console.log("错误状态码：" + response.status)
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        console.log("服务器连接异常,请检查服务器状态：" + error)
        return Promise.reject(error.response);
    }
);


// 记录confirm
var confirmIndex;

/**
 * 对外暴露
 */
export default {
    // post JSON 发送
    postJsonRequest: (url, data = {}, method = 'post', option = {}) => {
        data = GlobalFun.extendShallow({}, data)
        return new Promise((resolve, reject) => {
            let _option = Object.assign({
                url: url,
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            }, option);
            //console.log(_option);
            axios(_option).then(res => {
                // 成功
                if (res.data.code && res.data.code == 3) {
                	Message({
						message: res.data.msg,
						type: "error",
						showClose: true,
						dangerouslyUseHTMLString: true
					});
                    /*
                    if (!confirmIndex) {
                        confirmIndex = MessageBox.confirm(
                            '登录状态已过期，您可以继续留在该页面，或者重新登录',
                            '系统提示',
                            {
                                confirmButtonText: '重新登录',
                                cancelButtonText: '取消',
                                type: 'warning',
                                callback: function (action, instance) {
                                    confirmIndex = null;
                                    if (action == 'confirm') {
                                        // 移除 token
                                        window.localStorage.removeItem(GlobalVariable.TOKEN);
                                        // 移除 cookie
                                        Cookies.remove("username");
                                        Cookies.remove("usernameSecret");
                                        Cookies.remove("passwordSecret");
                                        // 登录页面
                                        window.location.href = window.location.href.replace(window.location.hash, '');
                                    }
                                }
                            }
                        ).then(() => {
                        });
                    }
                    */
                }
                
                // 异常
                if (res.data && res.data.excMessage) {
                	let excMessage = typeof res.data.excMessage == 'string' ? JSON.parse(res.data.excMessage) : Object.assign({}, res.data.excMessage);
                	if (excMessage.code != 0) {
	                	Message({
							message: excMessage.msg,
							type: "error",
							showClose: true,
							dangerouslyUseHTMLString: true
						});
						resolve(Object.assign({}, excMessage));
						return false;
                	}
                }
                
                resolve(res.data)
            }).catch(res => {
                // 失败
                reject(res)
            })
        })
    },
    error: {
        code: -1,
        msg: '系统维护中，请稍后再试！'
    },
    downFile: (url, name, method = 'get', responseType = 'blob') => {
        axios({
            method: method,
            url: url,
            responseType: 'blob'  // 二进制流文件
        }).then(res => {
            const link = document.createElement('a')
            const blob = new Blob([res.data])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }).catch(req => {
            console.log('error' + req)
        })
    },
    downloadAll(fileList = [], zipName) {
        const data = fileList; // 需要下载打包的路径, 可以是本地相对路径, 也可以是跨域的全路径
        const zip = new JSZip()
        const cache = {}
        const promises = []
        data.forEach(item => {
            const promise = this.getFile(item.url).then(data => {
                // 下载文件, 并存成ArrayBuffer对象
                const file_name = item.fName; // 获取文件名
                zip.file(file_name, data, {binary: true}) // 逐个添加文件
                cache[file_name] = data
            })
            promises.push(promise)
        })
        Promise.all(promises).then(() => {
            zip.generateAsync({type: 'blob'}).then(content => {
                // 生成二进制流
                FileSaver.saveAs(content, zipName) // 利用file-saver保存文件  自定义文件名
            })
        })
    },
    getFile(url){
        return new Promise((resolve, reject) => {
            axios.request({
                url: url,
                method: 'get',
                responseType: 'blob'
            }).then(data => {
                resolve(data.data)
            }).catch(error => {
                reject(error.toString())
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/request/request.js